import axios from "axios";
import { useDispatch } from "react-redux";
import { API_URL } from "src/config/constants";
import { logout } from "src/store/reducers/userInfo";
import { store } from "../store";
import { alert } from "./alert";

let reqInterceptor = null;
let resInterceptor = null;

export const setAxios = (token) => {
  axios.defaults.baseURL = API_URL;

  // console.log('reqInterceptor', reqInterceptor);
  // console.log('resInterceptor', resInterceptor);

  if (reqInterceptor !== null) {
    axios.interceptors.request.eject(reqInterceptor);
    reqInterceptor = null;
  }

  if (resInterceptor !== null) {
    axios.interceptors.response.eject(resInterceptor);
    resInterceptor = null;
  }

  if (token) {
    // console.log(axios.defaults.baseURL, token)
    reqInterceptor = axios.interceptors.request.use((config) => {
      // console.log('token', token);
      config.headers.Authorization = token;
      return config;
    });
  } else {
    reqInterceptor = axios.interceptors.request.use((config) => {
      return config;
    });
  }

  resInterceptor = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            store.dispatch(logout());
            break;
          case 404:
            alert("请求地址不存在！");
            break;
          case 400:
          case 403:
          case 500:
            if (error.response.data && error.response.data.msg) {
              alert(error.response.data.msg);
            } else {
              alert("后台服务出错！");
            }
            // console.log(error.response)
            break;
          default:
            break;
        }
      }
    }
  );
};



const requestMap = {};

export const asyncRequest = ({ method = "POST", path, data, fail = () => {}, complete = () => {} }) => {
  method = method.toUpperCase();

  const id = `${method}_${path}`;
  // console.log(id);
  // if (requestMap[id]) return Promise.reject();
  requestMap[id] = true;

  return new Promise(async (resolve, reject) => {
    axios({
      method,
      url: path,
      data,
    })
      .then((res) => {
        // console.log(res);
        if (!res) return;
        const { code, msg } = res.data;
        if (code === 1) {
          resolve(res.data);
        } else {
          alert(msg);
          reject();
        }
      })
      .catch((err) => {
        console.log(`request ${path} error: `, err.message);
        reject(err);
        fail(err);
      })
      .finally(() => {
        complete();

        requestMap[id] = false;
      });
  });
};
